import withClickOutside from './withClickOutside';

function withClickOutsideOnOverlay(WrappedComponent, closeBlockingClasses = [], customEscCb, customOutsideCb) {
    return withClickOutside(WrappedComponent, 'popup-form', closeBlockingClasses, customEscCb, customOutsideCb);
}

export default withClickOutsideOnOverlay;